export default __webpack_public_path__ + "static/media/img-guide-gt-popup-3-uk_en.ba38461e.png";